export { default as AppleAuthComponent } from './apple-auth.component';
